import React from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'; // Grid2 in mui 6
import { createTheme, ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import ACHForm from '../ACHForm/ACHForm';
import { AccountBox } from './AccountBox';
import { FlexAlerts, AlertSeverityTypes } from '../Message/Alerts/Alerts';

const theme = createTheme({
  palette: {
    cancel: {
      main: '#F50057',
      light: '#F50057',
      dark: '#DA0651',
      contrastText: '#FFFFFF',
    },
  },
});

const ACHEditAccount = (props) => {
  const {
    account = { accountNumber: '', routingNumber: '', bankName: '', accountType: '', accountName: '' }, // pass in any existing account details but not required
    updateAccount,
    onDone,
  } = props;
  const initialAccountDetails = {
    accountNumber: '',
    routingNumber: '',
    bankName: '',
    accountType: '',
    accountName: '',
    ...account,
  };
  const [isSaveDialogOpen, setIsSaveDialogOpen] = React.useState(false);
  const [messages, setMessages] = React.useState([]);
  const [editAccountDetails, setEditAccountDetails] = React.useState({ ...initialAccountDetails }); // add other fields for editing in case not included
  const achFormValidationRef = React.useRef(null);

  const checkIsValid = () => {
    let isValid = true;

    isValid = achFormValidationRef.current && achFormValidationRef.current.validate();

    return isValid;
  };

  const handleCancelEdit = () => {
    setEditAccountDetails(initialAccountDetails);
    onDone();
  };

  const handleChangeACH = (event) => {
    let { id, value } = event.target;

    setEditAccountDetails((prevAch) => ({
      ...prevAch,
      [id]: value,
    }));
  };

  const handleSaveAccount = () => {
    const tempMessages = [];
    setIsSaveDialogOpen(false);

    let isValid = true;

    // remove accountNumber from update if existing account
    if (account.maskedValue) {
      delete editAccountDetails.accountNumber;
    }

    if (!checkIsValid()) {
      isValid = false;
      tempMessages.push({ severity: AlertSeverityTypes.error, message: 'Missing values.' });
    }

    if (isValid) {
      updateAccount(editAccountDetails);
      onDone();
    }
    setMessages(tempMessages);
  };

  const handleCloseDialog = () => {
    setIsSaveDialogOpen(false);
    onDone();
  };

  return (
    <ThemeProvider theme={theme}>
      <AccountBox elevation={3}>
        <Grid container justifyContent={'space-between'} alignItems={'center'} rowSpacing={3}>
          <Grid item xs={8} md={9}>
            {account.bankName
              ? `${account.bankName} - ${account.accountType || 'N/A'} - ${account.maskedValue || '****'}`
              : 'New Account'}
          </Grid>
          {messages.length > 0 && (
            <Grid item xs={12} md={12}>
              <FlexAlerts messages={messages} />
            </Grid>
          )}
          <Grid item>
            <ACHForm
              variant="detailedBlock"
              ach={editAccountDetails}
              handleChangeACH={(e) => handleChangeACH(e)}
              ref={achFormValidationRef}
            />
          </Grid>
          <Grid item container justifyContent={'flex-end'} columnSpacing={2}>
            <Grid item>
              <Button id="SaveBankAccount" variant="contained" onClick={() => setIsSaveDialogOpen(true)}>
                Save Changes
              </Button>
              <Dialog open={isSaveDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>Save Changes</DialogTitle>
                <DialogContent>Are you sure you want to save changes to this bank account?</DialogContent>
                <DialogActions>
                  <Button onClick={handleSaveAccount} autoFocus>
                    Save
                  </Button>
                  <Button onClick={handleCloseDialog}>Cancel</Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <Grid item>
              <Button id="CancelEdit" variant="contained" color="cancel" onClick={(values) => handleCancelEdit(values)}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </AccountBox>
    </ThemeProvider>
  );
};

ACHEditAccount.propTypes = {
  account: PropTypes.object,
  updateAccount: PropTypes.func,
  onDone: PropTypes.func, // function to tell parent this component is done being rendered
};

export default ACHEditAccount;
